import { Injectable } from '@angular/core';

import { ToastrService } from "ngx-toastr";
@Injectable({
  providedIn: 'root'
})
export class AlertService {
  openNotifySuccess(message: string) {
    this.snotifyService.success(message, "", {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }

  openNotifyError(message: string) {
    this.snotifyService.error(message, "Something went wrong!!", {
     timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }









  openNotifyInfo(message: string) {
    this.snotifyService.info(message, "", {
      timeOut: 2000,
      progressBar: true,
      tapToDismiss: true,
    });
  }
  IDsForConnectedToAnotherComponent=[]
  constructor(private snotifyService: ToastrService) { }
}
